import {
  PosterModalBody,
  PosterModalClose,
  PosterModalContent,
  PosterModalMask,
  PosterModalTitle,
  PosterModalWrapper,
  QrCodeWrapper,
} from "./atom";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import QRCode from "qrcode.react";
import ShareBg from "./icon/share-bg.png";
import Logo from "./icon/renderbus-logo.png";
import { Button } from "task-eva-ui";
import { isDev } from "project-config/utils/env";
import { IUserInfo } from "../user-profile";

export function PosterModal({
  userInfo,
  handleClosePoster,
}: {
  userInfo?: IUserInfo;
  handleClosePoster: () => void;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const posterContentRef = useRef<HTMLDivElement>(null);
  const url = isDev()
    ? "https://task-pre.renderbus.com/sso/register"
    : "https://task.renderbus.com/sso/register";
  const [link, setLink] = useState("");
  const { t } = useTranslation("common");

  const handleSaveImg = () => {
    const posterContent = posterContentRef.current;
    const canvas = canvasRef.current;
    if (!canvas || !posterContent) return;
    html2canvas(posterContent)
      .then((renderedCanvas: any) => {
        const width = renderedCanvas.width;
        const height = renderedCanvas.height;
        console.log(width);
        console.log(height);
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx?.clearRect(0, 0, width, height);
        ctx?.drawImage(renderedCanvas, 0, 0, width, height);
        const dataURL = canvas?.toDataURL("image/png");
        const link = document.createElement("a");
        if (dataURL) {
          link.href = dataURL;
          link.download = "Renderbus瑞云渲染好友邀请福利分享海报.png";
          link.click();
        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (!userInfo) return;
    const link = `${url}?businessType=${userInfo?.businessType}&inviteId=${userInfo?.userId}`;
    setLink(link);
  }, [userInfo]);
  return (
    <PosterModalWrapper>
      <PosterModalMask />
      <PosterModalContent>
        <PosterModalTitle>
          <PosterModalClose
            onClick={(e) => {
              handleClosePoster();
              e.stopPropagation();
            }}
          />
        </PosterModalTitle>
        <PosterModalBody>
          <canvas ref={canvasRef} style={{ display: "none" }} />
          <div className="poster-content" ref={posterContentRef}>
            <img src={ShareBg} alt="" className="poster-bg" />
            <div className="poster-info">
              <img src={Logo} alt="" />
              <span title={userInfo?.userName}>{userInfo?.userName}</span>
            </div>
            <QrCodeWrapper>
              <QRCode size={160} value={link} />
            </QrCodeWrapper>
          </div>
          <Button onClick={handleSaveImg}>{t("animation_save")}</Button>
        </PosterModalBody>
      </PosterModalContent>
    </PosterModalWrapper>
  );
}
